import React from "react";
import PeopleIcon from "@atlaskit/icon/glyph/people";

import { Modal } from "../Modal";
import { useModalContext } from "../../contexts/ModalContext/context";
import { useUserContext } from "../../contexts/UserContext";
import { useSnackbar } from "../../hooks/useSnackbar";
import useAuth from "../../routes/login/AuthContext";
import { RemoveUserFromRoom } from "../../services/RoommateApi";

import { Button } from "../../UI/Button";
import { Box } from "../../UI/Box";
import { Typography } from "../../UI/Typography";
import { EMAIL_ADDRESS, PHONE_NUMBER } from "../../constants/general";
import { Link } from "../../UI/Link";

export const LeaveRoommateGroupModal = () => {
  const { setIsOpen } = useModalContext();
  const { user, loadUser } = useUserContext();
  const { showErrorSnackbar, showSuccessSnackbar } = useSnackbar();
  const [isLoading, setIsLoading] = React.useState(false);
  const { getAuthToken } = useAuth();

  const onHide = () => {
    setIsOpen(false);
  };

  const handleRemove = async () => {
    setIsLoading(true);

    if (!user) return;

    try {
      const success = await RemoveUserFromRoom(user.l1Id, user.membershipId, await getAuthToken());

      if (success.ok) {
        loadUser();
        showSuccessSnackbar("Successfully completed");
      } else {
        showErrorSnackbar("An error occured. Please try again");
      }
    } catch (error) {
      showErrorSnackbar("An error occured. Please try again");
    }
    setIsLoading(false);
    onHide();
  };

  return (
    <Modal
      title="Leave Roommate Group"
      actions={
        <>
          <Button appearance="subtle" onClick={onHide} isLoading={isLoading}>
            Cancel
          </Button>
          <Button
            appearance="primary"
            onClick={handleRemove}
            isLoading={isLoading}
            iconBefore={<PeopleIcon label="" />}
          >
            Leave Group
          </Button>
        </>
      }
    >
      <Box px={3} py={2}>
        <Typography variant="body2" gutterBottom>
          By clicking 'Leave Group', this user will be removed from their current roommates. Other roommates are not
          notified automatically of this action. The rest of the roommate group will stay connected.
        </Typography>
        <Typography variant="body2" gutterBottom>
          If you have questions about how this tool works, please call us at
          {PHONE_NUMBER} or e-mail <Link href={`mailto:${EMAIL_ADDRESS}`}>{EMAIL_ADDRESS}</Link>
        </Typography>
        <Typography variant="body2" gutterBottom>
          User to Remove: {user?.firstName} {user?.lastName}
        </Typography>
      </Box>
    </Modal>
  );
};
